import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  AppBar,
  Box,
  Container,
  Toolbar,
  Typography,
  Tabs,
  Tab,
  Paper,
  Divider
} from '@mui/material';
import useActiveClient from '../../hooks/useActiveClient';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const { activeClient, loading } = useActiveClient();
  
  const navItems = [
    { path: '/', label: 'Dashboard' },
    { path: '/search', label: 'Search' }
  ];

  // Find the current active tab index
  const currentTabIndex = navItems.findIndex(item => item.path === location.pathname) || 0;
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Header */}
      <AppBar position="static" sx={{ bgcolor: '#0066b7' }}>
        <Container maxWidth="lg">
          <Toolbar disableGutters>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Investec Payment Operations
            </Typography>
            {loading ? (
              <Typography variant="body2">Loading client information...</Typography>
            ) : activeClient ? (
              <Box sx={{ fontSize: '14px', display: 'flex', gap: 2 }}>
                <Typography variant="body2">
                  Active Client: <strong>{activeClient.name}</strong>
                </Typography>
                <Typography variant="body2">
                  ID: {activeClient.id}
                </Typography>
                <Typography variant="body2">
                  Business Area: {activeClient.businessArea}
                </Typography>
              </Box>
            ) : (
              <Typography variant="body2">No active client selected</Typography>
            )}
          </Toolbar>
        </Container>
      </AppBar>
      
      {/* Navigation */}
      <Paper square elevation={0} sx={{ borderBottom: '1px solid #dee2e6' }}>
        <Container maxWidth="lg">
          <Tabs
            value={currentTabIndex}
            TabIndicatorProps={{ style: { backgroundColor: '#0066b7' } }}
            sx={{
              '& .MuiTab-root': {
                color: '#555',
                '&.Mui-selected': {
                  color: '#0066b7',
                  fontWeight: 'bold'
                }
              }
            }}
          >
            {navItems.map((item) => (
              <Tab
                key={item.path}
                label={item.label}
                component={Link}
                to={item.path}
              />
            ))}
          </Tabs>
        </Container>
      </Paper>
      
      {/* Main Content */}
      <Box component="main" sx={{ flexGrow: 1, py: 3 }}>
        <Container maxWidth="lg">
          {children}
        </Container>
      </Box>
      
      {/* Footer */}
      <Box
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: 'auto',
          backgroundColor: theme => theme.palette.grey[100],
          borderTop: '1px solid #dee2e6'
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="body2" color="text.secondary" align="center">
            &copy; {new Date().getFullYear()} UK Private Banking - Payment Operations Portal
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            Version 1.0.0
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default Layout; 